export interface Movie {
  id: string;
  title: string;
  year: number;
  category: string;
  region: string;
  genres: string[];
  rating: number;
  popularity: number;
  duration: string;
  poster: string;
  backdrop: string;
  director: string;
  cast: string[];
  synopsis: string;
  tags: string[];
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "1",
    title: "星际回响",
    year: 2025,
    category: "电影",
    region: "美国",
    genres: ["科幻", "冒险"],
    rating: 8.9,
    popularity: 98,
    duration: "142 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20poster%20of%20a%20solitary%20astronaut%20silhouette%20drifting%20before%20a%20vast%20glowing%20nebula%2C%20deep%20blue%20and%20warm%20amber%20color%20palette%2C%20stylized%20minimal%20composition%2C%20subtle%20film%20grain%20texture%2C%20dramatic%20backlight%2C%20elegant%20negative%20space%20for%20titles%2C%20highly%20detailed&width=400&height=600&seq=mv-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20backdrop%20of%20a%20colossal%20space%20station%20orbiting%20a%20ringed%20planet%20at%20dawn%2C%20deep%20blue%20cosmic%20tones%20with%20warm%20amber%20rim%20light%2C%20volumetric%20light%2C%20stylized%20concept%20art%2C%20ultra%20detailed%2C%20atmospheric%20depth&width=1280&height=720&seq=mv-back-01&orientation=landscape",
    director: "艾略特·卡特",
    cast: ["林·诺兰", "苏菲·王", "马尔科·雷耶斯"],
    synopsis:
      "地球资源枯竭的最后十年，一支深空远征队携带着人类文明的备份驶向未知星系。当飞船接收到一段来自百年前的自我回响信号时，船长必须在拯救任务与拯救家人之间做出抉择。",
    tags: ["太空", "硬科幻", "亲情", "年度大片"],
    featured: true,
  },
  {
    id: "2",
    title: "长夜将明",
    year: 2024,
    category: "电影",
    region: "中国大陆",
    genres: ["剧情", "悬疑"],
    rating: 8.6,
    popularity: 92,
    duration: "128 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20drama%20film%20poster%20of%20a%20rain%20soaked%20neon%20city%20street%20at%20midnight%20with%20a%20lone%20figure%20in%20a%20long%20coat%20seen%20from%20behind%2C%20deep%20navy%20blue%20and%20warm%20streetlight%20amber%20glow%2C%20moody%20cinematic%20lighting%2C%20stylized%20painterly%20texture%2C%20high%20detail&width=400&height=600&seq=mv-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20backdrop%20of%20a%20wet%20city%20crosswalk%20at%20night%20reflecting%20neon%20signs%2C%20blurred%20pedestrians%20with%20umbrellas%2C%20deep%20navy%20tones%20and%20amber%20highlights%2C%20dramatic%20cinematic%20composition%2C%20stylized%20concept%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-02&orientation=landscape",
    director: "周浥尘",
    cast: ["陈知远", "许清和", "韩沐"],
    synopsis:
      "一名坚持追寻真相的记者，在城市最深的夜里追踪一桩被时间掩埋的旧案。随着线索逐渐清晰，他发现真相与自己的过去紧密相连，而黎明到来之前，每个人都必须面对自己的选择。",
    tags: ["悬疑", "社会派", "口碑佳片"],
    featured: true,
  },
  {
    id: "3",
    title: "潮汐之城",
    year: 2025,
    category: "电影",
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.2,
    popularity: 85,
    duration: "118 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20of%20a%20young%20couple%20standing%20close%20on%20a%20seaside%20pier%20at%20golden%20sunset%2C%20soft%20warm%20orange%20and%20gentle%20ocean%20blue%20palette%2C%20dreamy%20bokeh%2C%20stylized%20illustration%20texture%2C%20cinematic%20composition%2C%20elegant%20negative%20space&width=400&height=600&seq=mv-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20coastal%20backdrop%20of%20a%20quiet%20seaside%20town%20harbor%20at%20dusk%2C%20warm%20orange%20sky%20fading%20into%20soft%20blue%20sea%2C%20distant%20boats%20and%20warm%20window%20lights%2C%20dreamy%20atmosphere%2C%20stylized%20landscape%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-03&orientation=landscape",
    director: "河野真澄",
    cast: ["小林遥", "佐藤悠介", "森川葵"],
    synopsis:
      "在小城最老旧的灯塔下，两个正准备离开故乡的年轻人相遇。潮汐起落之间，他们用一整个夏天学会告别，也学会了留下。一段关于成长、故乡与初恋的温柔故事。",
    tags: ["治愈", "青春", "夏日"],
    featured: true,
  },
  {
    id: "4",
    title: "无声证词",
    year: 2024,
    category: "电影",
    region: "韩国",
    genres: ["犯罪", "悬疑"],
    rating: 8.7,
    popularity: 90,
    duration: "134 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20film%20poster%20of%20a%20detective%20standing%20in%20a%20dim%20interrogation%20room%2C%20single%20harsh%20overhead%20light%20casting%20long%20shadows%2C%20desaturated%20steel%20blue%20and%20amber%20accent%2C%20bold%20silhouette%2C%20stylized%20grain%20texture%2C%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=mv-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20scene%20backdrop%20of%20an%20empty%20rain%20slick%20city%20alley%20at%20night%20with%20a%20single%20flickering%20lamp%2C%20deep%20blue%20shadows%20and%20warm%20amber%20highlights%2C%20dramatic%20noir%20atmosphere%2C%20stylized%20concept%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-04&orientation=landscape",
    director: "朴正勋",
    cast: ["李泰成", "金秀雅", "郑宇彬"],
    synopsis:
      "一名老刑警接手了一桩没有目击者、没有物证的密室案件。唯一能说话的，是被害者留下的无声证词。当真相层层剥开，他意识到自己追捕的对象，或许正是最不该怀疑的人。",
    tags: ["犯罪", "推理", "反转"],
    featured: true,
  },
  {
    id: "5",
    title: "山海纪·焚天",
    year: 2025,
    category: "电视剧",
    region: "中国大陆",
    genres: ["奇幻", "古装"],
    rating: 8.4,
    popularity: 96,
    duration: "45 分钟 / 共 40 集",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20drama%20poster%20of%20a%20robed%20swordsman%20standing%20on%20a%20cliff%20before%20a%20burning%20sky%2C%20swirling%20clouds%20and%20floating%20embers%2C%20deep%20indigo%20and%20fiery%20orange%20palette%2C%20stylized%20ink%20wash%20texture%20with%20cinematic%20lighting%2C%20highly%20detailed&width=400&height=600&seq=mv-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20backdrop%20of%20ancient%20Chinese%20mountain%20peaks%20veiled%20in%20mist%20with%20a%20floating%20temple%20and%20glowing%20embers%2C%20deep%20indigo%20tone%20with%20warm%20orange%20highlights%2C%20stylized%20ink%20wash%20concept%20art%2C%20epic%20scale%2C%20high%20detail&width=1280&height=720&seq=mv-back-05&orientation=landscape",
    director: "苏牧云",
    cast: ["萧景行", "云知夏", "墨无声"],
    synopsis:
      "上古结界将破，焚天之火重现人间。身负残缺灵根的少年踏上寻找山海古卷的旅途，与狡黠的狐族少女、沉默的守碑人结伴。他们要在天火降临之前，解开封印千年之谜。",
    tags: ["仙侠", "大制作", "热血"],
    featured: true,
  },
  {
    id: "6",
    title: "暗涌档案",
    year: 2024,
    category: "电视剧",
    region: "英国",
    genres: ["悬疑", "剧情"],
    rating: 8.5,
    popularity: 82,
    duration: "52 分钟 / 共 12 集",
    poster:
      "https://readdy.ai/api/search-image?query=Suspense%20crime%20series%20poster%20of%20a%20blurred%20figure%20walking%20down%20a%20long%20dim%20office%20corridor%2C%20cold%20blue%20tone%20with%20warm%20amber%20exit%20light%2C%20strong%20geometric%20shadows%2C%20stylized%20texture%2C%20cinematic%20minimal%20composition%2C%20subtle%20grain%2C%20high%20detail&width=400&height=600&seq=mv-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20backdrop%20of%20a%20dim%20data%20center%20corridor%20with%20rows%20of%20servers%20and%20a%20lone%20silhouette%2C%20cold%20blue%20shadows%20with%20warm%20amber%20accent%20light%2C%20moody%20atmosphere%2C%20stylized%20concept%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-06&orientation=landscape",
    director: "奥利弗·格雷",
    cast: ["艾米莉亚·克拉克", "托马斯·里德", "娜奥米·科尔"],
    synopsis:
      "一名档案管理员在整理旧案卷宗时，发现了一批被人为抹去的编号。她循着数字背后的空白追查，卷入一场横跨三十年的隐秘博弈。每个被删除的档案，都藏着一个不肯沉默的人。",
    tags: ["英剧", "烧脑", "档案"],
    featured: false,
  },
  {
    id: "7",
    title: "春日便利店",
    year: 2025,
    category: "电视剧",
    region: "日本",
    genres: ["治愈", "剧情"],
    rating: 8.3,
    popularity: 78,
    duration: "30 分钟 / 共 10 集",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20slice%20of%20life%20drama%20poster%20of%20a%20small%20cozy%20convenience%20store%20at%20night%20with%20warm%20glowing%20windows%20and%20a%20friendly%20clerk%20silhouette%2C%20soft%20amber%20and%20gentle%20mint%20accents%2C%20stylized%20illustration%20texture%2C%20comforting%20atmosphere%2C%20high%20detail&width=400&height=600&seq=mv-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20backdrop%20of%20a%20quiet%20residential%20street%20in%20spring%20with%20blossom%20trees%20and%20a%20warmly%20lit%20corner%20store%2C%20soft%20pastel%20colors%20with%20warm%20amber%20glow%2C%20cozy%20slice%20of%20life%20atmosphere%2C%20stylized%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-07&orientation=landscape",
    director: "中村千夏",
    cast: ["冈田真央", "高桥莲", "井上结衣"],
    synopsis:
      "深夜值班的便利店店员，遇到了形形色色的过路人。每一集都是一位客人的小故事：加班的上班族、迷路的孩子、告别的恋人。小小的收银台前，串起了一整个春天的温度。",
    tags: ["治愈系", "单元剧", "生活"],
    featured: false,
  },
  {
    id: "8",
    title: "极速边缘",
    year: 2024,
    category: "电影",
    region: "美国",
    genres: ["动作", "犯罪"],
    rating: 7.8,
    popularity: 88,
    duration: "126 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20film%20poster%20of%20a%20sports%20car%20drifting%20through%20a%20rain%20soaked%20city%20tunnel%20with%20glowing%20light%20trails%2C%20deep%20blue%20shadows%20and%20intense%20orange%20sparks%2C%20dynamic%20motion%20blur%2C%20stylized%20cinematic%20texture%2C%20bold%20composition%2C%20high%20detail&width=400&height=600&seq=mv-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20backdrop%20of%20a%20nighttime%20urban%20highway%20with%20light%20trails%20and%20a%20speeding%20car%2C%20deep%20blue%20city%20glow%20with%20warm%20orange%20highlights%2C%20dynamic%20energy%2C%20stylized%20concept%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-08&orientation=landscape",
    director: "杰克·莫里森",
    cast: ["达米安·福特", "莉亚·钱伯斯", "瑞恩·奥特加"],
    synopsis:
      "退役赛车手被迫重返地下竞速，只为替弟弟偿还一笔致命的债务。引擎轰鸣的午夜街头，每一场比赛都可能成为最后一圈。速度带来自由，也带来无法回头的代价。",
    tags: ["飙车", "爽片", "动作大片"],
    featured: false,
  },
  {
    id: "9",
    title: "雾都疑影",
    year: 2023,
    category: "电视剧",
    region: "英国",
    genres: ["悬疑", "年代"],
    rating: 8.1,
    popularity: 70,
    duration: "50 分钟 / 共 8 集",
    poster:
      "https://readdy.ai/api/search-image?query=Victorian%20mystery%20film%20poster%20of%20a%20detective%20with%20a%20lantern%20walking%20through%20thick%20fog%20on%20cobblestone%20streets%2C%20muted%20teal%20blue%20and%20warm%20amber%20lantern%20glow%2C%20stylized%20painterly%20texture%2C%20atmospheric%20shadows%2C%20cinematic%20and%20detailed&width=400&height=600&seq=mv-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20backdrop%20of%20a%20foggy%20Victorian%20London%20street%20at%20night%20with%20gas%20lamps%20and%20silhouetted%20figures%2C%20muted%20teal%20blue%20and%20warm%20amber%20light%2C%20dramatic%20atmospheric%20composition%2C%20stylized%20concept%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-09&orientation=landscape",
    director: "克拉拉·休斯",
    cast: ["亨利·沃德", "伊莎贝尔·班克斯", "亚瑟·摩尔"],
    synopsis:
      "十九世纪的雾都，一位被警局除名的侦探以私人身份追查连环失踪案。浓雾笼罩的街巷里，真相被层层掩埋。他唯一的武器，是一双不肯放过任何细节的眼睛。",
    tags: ["年代剧", "侦探", "氛围感"],
    featured: false,
  },
  {
    id: "10",
    title: "奇妙星期六",
    year: 2025,
    category: "综艺",
    region: "中国大陆",
    genres: ["真人秀", "娱乐"],
    rating: 8.0,
    popularity: 84,
    duration: "60 分钟 / 每周六更新",
    poster:
      "https://readdy.ai/api/search-image?query=Energetic%20variety%20show%20poster%20with%20colorful%20stage%20lights%20confetti%20and%20a%20joyful%20host%20silhouette%20jumping%2C%20vibrant%20orange%20and%20deep%20blue%20party%20palette%2C%20playful%20geometric%20shapes%2C%20stylized%20graphic%20texture%2C%20fun%20cinematic%20mood%2C%20high%20detail&width=400&height=600&seq=mv-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20backdrop%20of%20a%20bright%20television%20studio%20stage%20with%20spotlights%20and%20confetti%2C%20vibrant%20orange%20and%20deep%20blue%20stage%20lighting%2C%20playful%20geometric%20set%20design%2C%20energetic%20atmosphere%2C%20stylized%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-10&orientation=landscape",
    director: "综艺制作中心",
    cast: ["主持团六人组"],
    synopsis:
      "每周六晚的欢乐时光，六位主持人带着明星嘉宾挑战脑洞大开的游戏。没有剧本设定的临场反应，笑料与惊喜轮番上演。一档适合全家一起收看的轻松综艺。",
    tags: ["娱乐", "轻松", "合家欢"],
    featured: false,
  },
  {
    id: "11",
    title: "深蓝之境",
    year: 2024,
    category: "纪录片",
    region: "英国",
    genres: ["自然", "纪录"],
    rating: 9.1,
    popularity: 76,
    duration: "55 分钟 / 共 6 集",
    poster:
      "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20of%20a%20majestic%20whale%20gliding%20through%20deep%20ocean%20water%20with%20sunbeams%20from%20above%2C%20rich%20deep%20blue%20gradient%20with%20soft%20teal%20highlights%2C%20stylized%20painterly%20texture%2C%20serene%20and%20breathtaking%2C%20high%20detail&width=400&height=600&seq=mv-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20ocean%20documentary%20backdrop%20of%20a%20vast%20deep%20sea%20scene%20with%20coral%20reef%20and%20rays%20of%20light%20piercing%20blue%20water%2C%20rich%20blue%20and%20teal%20gradient%2C%20serene%20underwater%20atmosphere%2C%20stylized%20concept%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-11&orientation=landscape",
    director: "BBC 自然史团队",
    cast: ["旁白：大卫·艾登堡"],
    synopsis:
      "从阳光能触及的浅海到万米之下的深渊，镜头第一次完整记录了深蓝世界的呼吸。发光的深海生物、迁徙的鲸群、从未被拍摄的珊瑚花园，共同讲述海洋最隐秘的故事。",
    tags: ["高分纪录片", "海洋", "震撼"],
    featured: false,
  },
  {
    id: "12",
    title: "两个夏天",
    year: 2025,
    category: "电影",
    region: "韩国",
    genres: ["爱情", "青春"],
    rating: 7.9,
    popularity: 80,
    duration: "112 分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Bittersweet%20romance%20film%20poster%20of%20two%20bicycles%20leaning%20together%20by%20a%20sunflower%20field%20under%20a%20bright%20summer%20sky%2C%20warm%20yellow%20and%20soft%20sky%20blue%20palette%2C%20nostalgic%20film%20grain%2C%20stylized%20illustration%20texture%2C%20tender%20composition%2C%20high%20detail&width=400&height=600&seq=mv-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20summer%20backdrop%20of%20a%20sunlit%20countryside%20road%20lined%20with%20sunflowers%20leading%20to%20distant%20hills%2C%20warm%20golden%20light%20and%20soft%20blue%20sky%2C%20nostalgic%20dreamy%20atmosphere%2C%20stylized%20landscape%20art%2C%20high%20detail&width=1280&height=720&seq=mv-back-12&orientation=landscape",
    director: "崔恩熙",
    cast: ["姜河那", "朴宝英", "边佑锡"],
    synopsis:
      "高考那个夏天，他们约好一起去远方。第二个夏天，一个人在原地等待，一个人早已换了方向。青春里最深的那段感情，往往没有对错，只有两个再也对不齐的夏天。",
    tags: ["青春", "初恋", "遗憾"],
    featured: false,
  },
];